import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const sidecarDeleteAtom = createMutationAtomFactory(
  'settings.sidecarDelete',
  (params: { id: string }) => ({
    iotSidecarDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
